import   axios                         from 'axios';

import { API_URLS                   }  from '../urls';

import { BackendResponse            ,
         handleError                }  from '../../dataTypes/backendServicesManagment/types';

export interface BackendResponse_Uuid extends BackendResponse<string> {}

export const createUuid = async (): Promise<BackendResponse_Uuid> => {

  const url = API_URLS.createUuid;

  try
   {
    const response = await axios.get(url);

    console.log (url, response)

    if (response.status === 200)
          {
		  
           return {
                    code: 1,
                    comment: 'L\'uuid a été généré avec succès.',
                    payload: response.data.uuid,
                  };
          }
     else {
           return handleError<string>(response.status, 'Réponse non-200 de l\'API');
          }
   }
  catch (error)
   {
    console.log(url, error);

    if (axios.isAxiosError(error))
     {
      return handleError<string>(-101, error.response?.data?.detail ?? error.message);
     }

    return handleError<string>(-102, 'Erreur inconnue');
  }
};
